import React from "react";
import {connect} from "react-redux";
import {Dimensions, StyleSheet, Text, TouchableOpacity, View, ScrollView} from "react-native";
import AvatarIcon from "../Header/AvatarIcon";

// focus picto
import FocusActivePicto from "../Picto/FocusActivePicto";
import FocusNotActivePicto from "../Picto/FocusNotActivePicto";
import FocusActiveCerclePicto from "../Picto/FocusActiveCerclePicto";
import FocusCerclePicto from "../Picto/FocusCerclePicto";
// notif picto
import NotifActiveCerclePicto from "../Picto/NotificationActiverActiveCerclePicto";
import NotifCerclePicto from "../Picto/NotificationActiverCerclePicto";
import FooterNotifActivePicto from "../Picto/FooterNotificationActivePicto";
import FooterNotifPicto from "../Picto/FooterNotificationPicto.tsx";
// other picto
import ConfidentialPicto from "../Picto/ConfidentialPicto";

import PostCategorie from "../Feed/PostFeed/PostCategorie";
import {wrapAction, wrapStyle} from "../../sw/helpers";
import Positions from "./Positions";


function getStyle(theme, avatar) {
    const { width, height } = Dimensions.get('window');

    return StyleSheet.create({
	container:{
	    marginHorizontal:10,
	    marginBottom:12,
	    flexDirection:"row",
	    backgroundColor:theme.colors.primary.White.value,
	    padding:12,
	    borderRadius:7,
	    minHeight:60,
	    maxWidth:width
	},
	// <container><icon/><containerText/><updatefooter/></container>
	icon :{
	    marginLeft:0,
	    width:40,
	    height:40,
	    borderRadius:15,
	    marginRight:10,
	    display:(!avatar)? "none":"flex"
	},
	containerText:{
	  flexGrow: 1,
	  flexShrink: 1,
	},
	update_footer: wrapStyle({
	  display: "flex",
	  flexDirection: "row",
	  flexGrow: 0,
	  flexShrink: 0,
	}),
	trendingPostCategory: {
	  marginRight: 10
	},
	titre:{
	    fontFamily: theme.fonts.text_bold,
	    fontWeight:"500",
	    //width:'80%',
	    color : theme.colors.tertiary.black1.value,
	    fontSize:15,
	    marginBottom:3,
	    lineHeight: 40,
	    maxWidth:250
	},
	sousTitre:{
	    fontFamily: theme.fonts.text,
	    color : theme.colors.tertiary.black6.value,
	    //width:'80%',
	    fontSize:13,
	    marginBottom:5,
	    lineHeight: 22
	},
	article:{
	    fontFamily: theme.fonts.text,
	    color : theme.colors.primary.blue1.value,
	    fontSize:13
	},
	containerLien :{
	    flexDirection: 'row',
	},
	lien:{
	    borderWidth: 1,
	    borderStyle: "solid",
	    marginRight: 10,
	    borderRadius:60,
	    paddingVertical:4,
	    paddingHorizontal:12,
	    fontFamily : theme.fonts.text,
	    fontSize : 13,
	}
    })
}

const safeColor = (color) => {
  return color.replace(/[^a-zA-Z0-9()#]/g, "")
}

const LinkTags = ({ links, styles }) => {
  if (links.length === 0) return null;

  return <ScrollView style={styles.containerLien} horizontal={true}>{
      links
      .filter(l => l.type)
      .map(l => {
       const color = safeColor(l.poi_link_category.color);
       return <Text key={l.id} numberOfLines={1} style={[styles.lien, {color: color, borderColor: color}]}>{l.type}</Text>
      })
  }</ScrollView>
}

class TendancetListItem extends React.Component{
    constructor(props) {
        super(props);
        this.item = this.props.item;
        this._navigateToTendancePostFeed = this._navigateToTendancePostFeed.bind(this);
        this._navigateToEntityScreen = this._navigateToEntityScreen.bind(this);
        this.onPress = this.onPress.bind(this);
    }

    _navigateToTendancePostFeed(){
        let type;
        let name = "";
        if(this.props.isTheme){
            type = "theme";
            name = this.item.item;
        }else if(this.props.isEntity){
            type = 'entity';
            name = this.item.name;
        }else{
            type = "contact";
            name = this.item.firstname + " " + this.item.lastname;
        }

        this.props.refNavigation.navigate("TendancePostFeed", {
	  screen:"TendancePostFeed",
	  type, name,
	  id: this.item.id,
	  nbArticle: this.item.total_counts,
	  tendanceFeedId: 1,
	});
    }

    _navigateToEntityScreen(){
        let id = this.props.item.id;
        let type=this.props.type;
        if(this.props.isLink){
            if(this.props.isTheme){
                type = "theme";
               id = this.props.item.poi_theme.id
            }else if(this.props.isEntity){
                type = 'entity';
                id = this.props.item.poi_entity.id ;
            }else{
                type = "contact";
                id = this.props.item.poi_contact.id ;
            }
        }

        this.props.refNavigation.navigate("EntityScreen",{type:type,id:id});
    }

    getContactView(trending_view, shared_footer, styles) {
      const {isLink, item} = this.props;

      if (isLink) {
        // it might be a theme faking it
        return <View style={styles.container}>
          <AvatarIcon style={styles.icon} icon={item.poi_contact.img} />
          <View style={styles.containerText}>
            <Text style={styles.titre}>{item.poi_contact.firstname} {item.poi_contact.lastname}</Text>
            <Text style={styles.sousTitre}>{item.poi_contact.extra_data.full_mandat}</Text>
            <LinkTags links={item.links} styles={styles} />
	    { item.poi_contact.grid_node && <Positions node={item.poi_contact.grid_node } /> }
          </View>
          { shared_footer }
        </ View>
      }

      return <View style={styles.container}>
         { item.img  && <AvatarIcon style={styles.icon} icon={item.img} /> }
         <View style={styles.containerText}>
           <Text numberOfLines={1} style={styles.titre}>{item.firstname} {item.lastname}</Text>
           { trending_view }
         </View>
         { shared_footer }
      </View>
    }

    getEntityView(trending_view, shared_footer, styles) {
       const {isLink, item} = this.props;

       if (isLink) {
	 // it might be a theme faking it
	 return <View style={styles.container}>
	    <AvatarIcon  style={styles.icon} icon={item.poi_entity.img} />
	    <View style={styles.containerText}>
		<Text numberOfLines={1} style={styles.titre}>{item.poi_entity.name}</Text>
		<Text numberOfLines={1} style={styles.sousTitre}>{item.poi_entity.label}</Text>
		<LinkTags links={item.links} styles={styles} />
		{ item.poi_entity.grid_node && <Positions node={item.poi_entity.grid_node } /> }
	    </View>
	    { shared_footer }
	 </View>
       }

       return <View style={styles.container}>
	  { item.img  && <AvatarIcon  style={styles.icon} icon={item.img} /> }
	  <View style={styles.containerText}>
	      <Text numberOfLines={1} style={styles.titre}>{item.name}</Text>
	      { trending_view }
	  </View>
	  { shared_footer }
       </View>
    }

    getThemeView(trending_view, shared_footer, styles) {
       const {isLink, item} = this.props;
       return <View style={styles.container}>
	   <View style={styles.containerText}>
	     <View style={{flexDirection: "row", alignItems: "center"}}>
	       {!isLink && <Text numberOfLines={1} style={styles.titre}>{item.item}</Text>}
	       { item.confidential && <ConfidentialPicto style={{width: 16, height: 16, marginLeft: "2px"}} isHeader={true}/> }
	     </View>

	     { trending_view }
	     { isLink  && <View numberOfLines={1} style={styles.containerLien}><Text style={styles.lien}>{item.type}</Text></View>}
	   </View>

	   { shared_footer }
      </View>
    }

    sharedFooter(styles) {
      const {
        isUpdate, isFocus,
        isFocused, isInFocusSetList, isInFocusUnSetList, setFocusList,
        isNotification, isInNotificationSetList, isInNotificationUnSetList, setNotificationList
      } = this.props

      // Don't show any notif/focus icons except in focus mode (not explorer/trending)
      if (!isFocus) {
        return <View />
      }

      const setFocus = () => {
        const is_focused = !this.props.isInFocusUnSetList && (this.props.isFocused || this.props.isInFocusSetList);
        this.props.setFocusList(this.props.type, !is_focused, this.props.item)
      }

      const setNotification = () => {
        const is_notification = !this.props.isInNotificationUnSetList && (this.props.isNotification || this.props.isInNotificationSetList);
        this.props.setNotificationList(this.props.type, !is_notification, this.props.item)
      }

      const notif_style = {width: 21};
      const focus_style = {width: 25, marginLeft: 15};

      const notif_cercle_style = {width: 30};
      const focus_cercle_style = {width: 30, marginLeft: 15};

      const notif_active_icon = !isInNotificationUnSetList && (isNotification || isInNotificationSetList) ? <NotifActiveCerclePicto isHeader={true} style={notif_cercle_style} /> : false;
      const notif_icon = (isInNotificationUnSetList || (!isNotification && !isInNotificationSetList)) ? <NotifCerclePicto isHeader={true} style={notif_cercle_style} /> : false;

      const focus_active_icon = !isInFocusUnSetList && (isFocused || isInFocusSetList) ? <FocusActiveCerclePicto isHeader={true} style={focus_cercle_style} /> : false;
      const focus_icon = (isInFocusUnSetList || (!isFocused && !isInFocusSetList)) ? <FocusCerclePicto isHeader={true} style={focus_cercle_style} /> : false;

      if (!isUpdate) {
	// readonly icons
	return <View style={styles.update_footer}>
	  { notif_active_icon && <FooterNotifActivePicto isHeader={true} style={notif_style} /> }
	  { notif_icon && <FooterNotifPicto isHeader={true} style={notif_style} /> }
	  { focus_active_icon && <FocusActivePicto isHeader={true} style={focus_style} /> }
	  { focus_icon && <FocusNotActivePicto isHeader={true} style={focus_style} /> }
	</View>
      }

      return <View style={styles.update_footer}>
	{
          (notif_icon || notif_active_icon) &&
	  <TouchableOpacity onPress={wrapAction(setNotification)}>
	    { notif_active_icon || notif_icon }
	  </TouchableOpacity>
	}
	{
          (focus_active_icon || focus_icon) &&
	  <TouchableOpacity onPress={wrapAction(setFocus)}>
	    { focus_active_icon || focus_icon }
	  </TouchableOpacity>
	}
      </View>
    }

    trendingView(styles) {
      if (!this.props.hideArticle && this.props.isEntityScreen!==true) {
        const counts = this.props.item.counts;
        const sorted_type = Object.keys(counts).sort((a, b) => counts[a] < counts[b]);

        return <Text>
          {
	    sorted_type.map((type, i) => <View style={styles.trendingPostCategory} key={i}>
	      <PostCategorie type={type} prefix={counts[type]} />
	    </View>
	  )}
        </Text>
      }
      return null;
    }

    onPress() {
      if (this.props.isExplorer || this.props.isFocus) {
	this._navigateToEntityScreen();
      } else {
	this._navigateToTendancePostFeed();
      }
    }

    render() {
	const {type} = this.props;

        const styles = getStyle(this.props.theme, this.props.avatar)
        const shared_footer = this.sharedFooter(styles);
        const trending_view = this.trendingView(styles);

	let view = null;
        if (type == 'contact' || type == 'Contacts') {
          view = this.getContactView(trending_view, shared_footer, styles);
        } else if (type == 'entity' || type == 'Entity') {
          view = this.getEntityView(trending_view, shared_footer, styles);
        } else if (this.props.isTheme) {
          view = this.getThemeView(trending_view, shared_footer, styles);
        }

        if (this.props.isUpdate) {
          return view;
        } else {
          return <TouchableOpacity onPress={this.onPress}>{ view }</TouchableOpacity>;
        }
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default connect(mapStateToProps)(TendancetListItem);
